<template>
    <main class="admin-data">
        <v-data-table
            :headers="headers"
            :items="list"
            :loading="loading"
            :hide-actions="true"
            :no-data-text="$t('message.generics.message.noData')"
            :no-results-text="$t('message.generics.message.noData')"
            sort-icon="mdi-chevron-down"
        >
            <v-progress-linear
                slot="progress"
                :color="providerColor"
                indeterminate
            />

            <template slot="items" slot-scope="props">
                <AdminDataTableItem :item="props.item" />
            </template>
        </v-data-table>

        <infinite-loading :identifier="infiniteId" @infinite="load">
            <div slot="no-results"></div>
            <div slot="no-more"></div>
        </infinite-loading>

        <AdminDataReportStatus v-if="reportStatus" :status="reportStatus" />
    </main>
</template>

<script>
import AdminDataTableItem from "@views/admin/data/components/AdminDataTableItem";
import AdminDataReportStatus from "@views/admin/data/components/report/AdminDataReportStatus";
import InfiniteLoading from "vue-infinite-loading";
import EventBus from "@packages/event-bus";
import provider from "@mixins/provider";

export default {
    components: {
        InfiniteLoading,
        AdminDataTableItem,
        AdminDataReportStatus,
    },

    data() {
        return {
            infiniteId: +new Date(),
            list: [],
            loading: false,
            page: 0,
            reportStatus: undefined,
            statusInterval: undefined,
        };
    },

    computed: {
        headers() {
            return [
                {
                    text: this.$t("message.admDataReport.message.date"),
                    value: "",
                    sortable: false,
                },
                {
                    text: this.$t("message.statistics.message.totalUsers"),
                    value: "",
                    sortable: false,
                },
                {
                    text: this.$t("message.statistics.message.uniqueUsers"),
                    value: "",
                    sortable: false,
                },
                {
                    text: this.$t("message.statistics.message.newUsers"),
                    value: "",
                    sortable: false,
                },
                {
                    text: this.$t("message.generics.message.accesses"),
                    value: "",
                    sortable: false,
                },
                {
                    text: this.$t("message.statistics.message.impressions"),
                    value: "",
                    sortable: false,
                },
                {
                    text: this.$t("message.statistics.message.abandonment"),
                    value: "",
                    sortable: false,
                },
            ];
        },
    },

    mounted() {
        this.loadReportStatus().then(() => {
            if (this.reportStatus) {
                this.setReportStatusLoadInterval();
            }
        });

        EventBus.$on(
            "ADMIN_DATA_REPORT_STARTED",
            this.setReportStatusLoadInterval
        );
    },

    beforeDestroy() {
        clearInterval(this.statusInterval);
        EventBus.$off(
            "ADMIN_DATA_REPORT_STARTED",
            this.setReportStatusLoadInterval
        );
    },

    mixins: [provider],

    methods: {
        setReportStatusLoadInterval() {
            if (this.statusInterval) {
                clearInterval(this.statusInterval);
            }

            this.loadReportStatus();

            this.statusInterval = setInterval(this.loadReportStatus, 30000);
        },
        async loadReportStatus() {
            const reportStatus = await this.$api.report.status();

            if (reportStatus) {
                this.reportStatus = reportStatus;
            } else if (reportStatus === null) {
                EventBus.$emit("ADMIN_DATA_REPORT_END");
                this.reportStatus = undefined;
                clearInterval(this.statusInterval);
            }
        },
        async load($state) {
            this.loading = true;

            try {
                const list = await this.$api.core.statistics.dayData({
                    page: this.page,
                });

                if (list.length) {
                    this.list.push(...list);

                    this.page++;

                    $state.loaded();
                } else {
                    $state.complete();
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped></style>
